import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Events, NavParams } from "ionic-angular";
import { PainSiteService } from "../../pain-site-card/pain-site.service";
import { NewWoundService } from "../new-wound.service";
@Component({
  selector: "new-wound-summary",
  templateUrl: "new-wound-summary.html",
})
export class NewWoundSummaryComponent {
  painService: PainSiteService;
  notes: any;
  config: any;
  notesConfig: any;
  data: any;
  sidebar: any;

  constructor(
    private newWoundService: NewWoundService,
    public translatePipe: TranslateService,
    public events: Events,
    params: NavParams
  ) {
    let data = params.data;
    this.config = data.config;
    this.painService = this.newWoundService.getPainService();
  }

  ngOnInit(): void {
    for (let i = 0; i < this.config.tabs.length; i++) {
      if (this.config.tabs[i].summary) {
        for (let j = 0; j < this.config.tabs[i].summary.length; j++) {
          if (this.config.tabs[i].summary[j].sidebar)
            this.sidebar = this.config.tabs[i].summary[j].sidebar;
          if (this.config.tabs[i].summary[j].notes)
            this.notesConfig = this.config.tabs[i].summary[j].notes;
        }
      }
    }

    this.newWoundService.getCurrentPointData().subscribe((currentWound) => {
      if (currentWound) {
        this.data = currentWound;
        if (currentWound.notes) {
          this.notes = currentWound.notes;
        }
      }
    });
  }

  updateCardData() {}
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound-summary/new-wound-summary.ts